import PropTypes from "prop-types";

// import Mui components
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";

import ActionStandardTooltipData from "../ActionStandardTooltipData";
import { useSelector } from "react-redux";
const NoMaxWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
    />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        background: "linear-gradient(90deg, rgba(191, 242, 255, 1) 0%, rgba(195, 215, 255, 1) 100%)",
        borderRadius: "5px",
        padding: "5px",
    },
});

function ActionsStandardLabel({ actionStandardKpis = [], actionStandardData, moduleName, defaultTitle = "" }) {
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);
    const studyType = selectedStudy.length > 0 ? selectedStudy[0]?.study_type__title : "";
    const studyTypeMethod = selectedStudy.length > 0 ? selectedStudy[0]?.study_type_method__title : "";
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellbeing = isHairCare || isSkinCare;
    const variableCategoryStoreData = useSelector((state) => state.dataMappingStore.backendVariableVariableCategory);

    const hasRelevantData = !isBeautyAndWellbeing
        ? true
        : actionStandardData?.some((datum) => {
              const categories = datum?.action_standard_kpis?.flatMap((item) => item?.kpi?.map((k) => variableCategoryStoreData?.[k?.backend_variable])) || [];

              if (moduleName === "agreement") {
                  return categories.includes("Agreement KPI");
              }

              if (moduleName === "justRight") {
                  return categories.includes("JAR");
              }

              return true; // overall
          });

    return (
        actionStandardKpis.length !== 0 &&
             hasRelevantData && (
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "sticky",
                    left: 0,
                }}
            >
                <p
                    style={{
                        margin: "0px 10px",
                        color: "#495057",
                        fontWeight: 600,
                        fontSize: 14,
                    }}
                >
                    Note - *Action Standard Kpi
                </p>

                <NoMaxWidthTooltip
                    title={
                        <div
                            style={{
                                maxHeight: "80vh",
                                overflowY: "auto",
                            }}
                        >
                            {" "}
                            <ActionStandardTooltipData
                                data={actionStandardData}
                                studyType={studyType}
                                studyTypeMethod={studyTypeMethod}
                                defaultTitle={defaultTitle}
                            />
                        </div>
                    }
                    placement="left-start"
                    leaveDelay={500}
                >
                    <IconButton
                        aria-label="open"
                        sx={{
                            background: "rgb(51, 94, 234) !important",
                            color: "#fff",
                        }}
                        size="small"
                    >
                        <TouchAppOutlinedIcon
                            style={{
                                fontSize: 16,
                            }}
                        />
                    </IconButton>
                </NoMaxWidthTooltip>
            </div>
        )
    );
}

ActionsStandardLabel.propTypes = {
    actionStandardKpis: PropTypes.array,
    actionStandardData: PropTypes.array,
    moduleName: PropTypes.string,
    defaultTitle: PropTypes.string,
};

export default ActionsStandardLabel;
